<div class="row mt-3" *ngIf="!global.employeetoAgreementEmit">
    <!-- *ngIf="!employeeBO.edit && ListemitBo.employeeToDocument" -->
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent">
                <div class="col p-0">
                    <label class="mt-1 fw-bold fs-4">Employee Agreement</label>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="d-flex col-lg-3 col-md-6 col-12"
                        *ngIf="global.OnboardingLoginType !='onboardLogin' || getloginUser=='CLIENT'">
                        <div class="col-6 p-0">
                            <label class="mt-1">Employer Status</label>
                        </div>
                        <div class="col-6 p-0">
                            <ng-select [(ngModel)]="agreementlistBo.employerstatusLid" [searchable]="true"
                                [clearable]="true" [items]="statuslist" bindLabel="lovName" bindValue="id"
                                [disabled]="global.viewEmployeeTabs" (ngModelChange)="filterChange()">
                            </ng-select>
                        </div>
                    </div>
                    <div class="d-flex col-lg-3  col-md-6 col-12"
                        *ngIf="global.OnboardingLoginType !='onboardLogin' || getloginUser=='EMPLOYEE'">
                        <div class="col-6 p-0">
                            <label class="mt-1">Employee Status</label>
                        </div>
                        <div class="col-6 p-0">
                            <ng-select [(ngModel)]="agreementlistBo.employeestatusLid" [searchable]="true"
                                [clearable]="true" [items]="statuslist" bindLabel="lovName" bindValue="id"
                                [disabled]="global.viewEmployeeTabs" (ngModelChange)="filterChange()">
                            </ng-select>
                        </div>
                    </div>
                    <div class="d-flex col-lg-3  col-md-6 col-12">
                        <div class="col-6 p-0">
                            <label class="mt-1">Completed Status</label>
                        </div>
                        <div class="col-6 p-0">

                            <ng-select class="w" [items]="completedlist" [searchable]="true"
                                [(ngModel)]="agreementlistBo.completed" [clearable]="true" bindLabel="lovName"
                                bindValue="id" (ngModelChange)="filterChange()" [disabled]="global.viewEmployeeTabs">
                            </ng-select>
                        </div>
                    </div>
                    <!-- <div class="b4">
                            <div class="input-group">
                                <input type="text" class="form-control element_width" [(ngModel)]="client_search"
                                    placeholder="search client">
                                <div class="input-group-addon">
                                    <button class="i-btn"> <i class="fa fa-search mt-1"
                                            (click)="FilterOnboardEmpData()"></i> </button>
                                </div>
                            </div>
                        </div> -->
                    <div class="col-lg-3  col-md-6 col-sm-12  text-end"
                        *ngIf="global.OnboardingLoginType !='onboardLogin'">


                        <button class="btn btn-sm" [disabled]="global.viewEmployeeTabs" (click)="Refresh()">
                            Refresh</button>&nbsp;&nbsp;&nbsp;

                        <button class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#clientdropdownmodal"
                            [disabled]="global.viewEmployeeTabs" (click)="getClientforDoc()"  *ngIf="fp.employeedocumentcreate">Create
                            Agreement</button>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col " *ngIf="global.OnboardingLoginType =='onboardLogin'">
        <div widget class="card border-0 box-shadow">
            <div class="card-body">
                <div class="row">
                    <div class=" col-lg-3 col-md-6 col-12">
                        <div class="col p-0">
                            <label class="mt-1 fw-bold fs-4">Employee Agreement</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div> -->
</div>

<div class="row mb-2" *ngIf="!global.employeetoAgreementEmit">
    <div class="col">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <ejs-grid #grid [allowResizing]='true' [dataSource]='agreementData |async'                
                [allowPaging]='true' [allowResizing]='true' [allowFiltering]='true'
                [pageSettings]='initialPage' [filterSettings]='filterSettings' 
                [showColumnChooser]='true' [allowSorting]='true' [allowPdfExport]='true'
                (actionBegin)="onActionComplete($event)" (dataStateChange)="dataStateChange($event)">
                    <e-columns>
                        <!--  -->
                        <!-- " -->
                        <e-column maxWidth=250 headerText="Actions" uid="action" textAlign="center"
                            [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                                <button class="btn btn-sm" (click)="EditAgreement(data,'edit')" [disabled]="global.viewEmployeeTabs"
                                    style="background-color:#00786a ;" title="view"  *ngIf="fp.employeedocumentupdate"><i class="fa fa-eye"  ></i></button>
                                &nbsp;

                                <button ejs-button class="btn btn-sm" style="background-color:#00786a ;"
                                (click)="EditAgreement(data,'print')" title="Download"> <i
                                        class="fa fa-print"></i></button> &nbsp;

                                <button class="btn btn-sm" style="background-color:#00786a ;" title="Note"
                                    (click)="getOfficeNotes(data)" data-bs-toggle="modal"
                                    data-bs-target="#modalofficeNotes"
                                    *ngIf="this.global.OnboardingLoginType !='onboardLogin'"><i
                                        class="fa fa-sticky-note-o"></i></button>
                                &nbsp;
                                <button class="btn btn-sm"  data-bs-toggle="modal"
                                data-bs-target="#modalEmpAggrementdelete" (click)="DeleteAgreement(data)" [disabled]="global.viewEmployeeTabs"
                                title="view"  *ngIf="this.global.OnboardingLoginType !='onboardLogin'"><i class="fa fa-trash"  ></i></button>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="officeNotes" headerText="Office Notes" type='string'
                            *ngIf="this.global.OnboardingLoginType !='onboardLogin'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="employerName" headerText="Employer Name" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=120 field="employerstatus" headerText="Employer Status" type='string'
                            *ngIf="this.global.OnboardingLoginType !='onboardLogin'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=120 field="statusName" headerText="Employer Status" type='string'
                            *ngIf="this.global.OnboardingLoginType =='onboardLogin' && getloginUser=='CLIENT'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="employeeName" headerText="Employee Name"
                            *ngIf="this.global.OnboardingLoginType =='onboardLogin'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="employeestatus" headerText="Employee Status"
                            *ngIf="this.global.OnboardingLoginType !='onboardLogin'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="employeestatus" headerText="Employee Status"
                            *ngIf="this.global.OnboardingLoginType =='onboardLogin' && getloginUser=='EMPLOYEE'">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="isCompleted" headerText="Is Completed?" 
                            textAlign="center">
                            <ng-template #template let-data>
                                <button  class="border-0" *ngIf="data.isCompleted ==false"
                                    title="Not Completed"><i class="fa fa-times"
                                        style="font-size:30px; color:red;"></i></button>
                                <button  class="border-0" *ngIf="data.isCompleted ==true" title="Completed"><i
                                        class="fa fa-check" style="font-size:30px; color:green;"></i></button>



                            </ng-template>
                        </e-column>


                        <!-- <e-column minWidth=60 field="IsCompleted" headerText="Is Completed ?" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column> -->
                        <!-- <e-column minWidth=60 field="statusChangeDate" headerText="Status Changed Date"
                            [allowFiltering]='false' type='date' [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column> -->
                        <!-- <e-column minWidth=120 field="employerNotes" headerText="Employer Notes" type='string'>
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column> -->

                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>



<span id="clientdropdownmodalOpen" data-bs-toggle="modal" data-bs-target="#clientdropdownmodal"></span>
<div class="modal fade modalbackgrod" id="clientdropdownmodal" tabindex="-1" aria-labelledby="clientdropdownmodalLabel"
    aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog mt-5 pt-5" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="clientdropdownmodalLabel">Choose Employer</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <label class="">Employer<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select [(ngModel)]="clientid" [items]="clientlist" bindValue="id" bindLabel="clientName">

                        </ng-select>

                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <label class="">Template Name</label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select [(ngModel)]="templateid" [items]="templateList" bindValue="id" bindLabel="name">

                        </ng-select>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!--  -->
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                    [disabled]="clientid==null || clientid=='' || clientid==undefined"
                    (click)="openAgreement()">Go</button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<app-employee-agreement (dataEmitFromOnboard)="dataEmitFromOnboard($event)" *ngIf="open_agreement &&(this.employeeBO.edit||this.employeeBO.print)"
    [employeeBO]="employeeBO"></app-employee-agreement>


<!----------------------------------------------Emp Doc Download------------------------------------------------------------>

<span id="openOfficeNotes" data-bs-toggle="modal" data-bs-target="#modalofficeNotes"></span>
<div class="modal hide modalbackgrod" id="modalofficeNotes" tabindex="-1" aria-labelledby="modalofficeNotesLabel"
    aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog  ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="modalofficeNotesLabel">Office Notes</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearFields()"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-4">
                        <label class="mt-4">Notes<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
                    </div>
                    <div class="col-lg-6">
                        <textarea class="form-control" style="width: 249px;height: 72px;"
                            [(ngModel)]="employeeOfficeNotesBo.officenotes">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" (click)="SaveOfficeNotes()" [disabled]="employeeOfficeNotesBo.officenotes==null||
        employeeOfficeNotesBo.officenotes==undefined||employeeOfficeNotesBo.officenotes==''"><span>Save</span>
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearFields()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="openEmployeeAggrdelete" data-bs-toggle="modal" data-bs-target="#modalEmpAggrementdelete"></span>
<div class="modal hide modalbackgrod" id="modalEmpAggrementdelete" tabindex="-1" aria-labelledby="modalofficeNotesLabel"
aria-hidden="true" data-bs-backdrop="false"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

  
   
